export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'platform', name: '平台公告', icon: 'ri-megaphone-line' },
  { id: 'tutorial', name: '使用教程', icon: 'ri-book-open-line' },
  { id: 'update', name: '功能更新', icon: 'ri-rocket-line' },
  { id: 'case', name: '客户案例', icon: 'ri-star-line' },
  { id: 'industry', name: '行业资讯', icon: 'ri-newspaper-line' }
];

export const articles = [
  {
    id: 1,
    category: 'platform',
    title: 'JMTT平台2026年第三季度发展规划与战略布局',
    excerpt: '随着数字化转型浪潮不断深入，JMTT在2026年第三季度将继续加大技术研发投入，推出多项重磅功能，为用户提供更加完善的平台体验。本文将详细解读JMTT最新战略规划。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20with%20digital%20displays%20showing%20data%20analytics%2C%20minimalist%20interior%20design%2C%20warm%20ambient%20lighting%2C%20professional%20workspace%20atmosphere%2C%20clean%20aesthetic%20with%20geometric%20elements&width=800&height=450&seq=article-01&orientation=landscape',
    author: 'JMTT官方',
    date: '2026-08-10',
    readTime: '5分钟',
    tags: ['发展规划', '平台战略', '技术升级']
  },
  {
    id: 2,
    category: 'tutorial',
    title: 'JMTT新用户入门指南：从注册到精通只需三步',
    excerpt: '刚加入JMTT不知道从哪里开始？本教程将手把手教你完成账号注册、基础功能配置以及核心工具的使用方法，帮助你在最短时间内上手JMTT平台，快速开启高效工作之旅。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20showing%20onboarding%20screen%2C%20minimalist%20desk%20setup%2C%20warm%20natural%20light%2C%20professional%20yet%20friendly%20atmosphere%2C%20simple%20flat%20lay%20composition&width=800&height=450&seq=article-02&orientation=landscape',
    author: 'JMTT教程团队',
    date: '2026-08-08',
    readTime: '8分钟',
    tags: ['新手教程', '注册指南', '入门']
  },
  {
    id: 3,
    category: 'update',
    title: 'JMTT v4.2版本更新：智能分析模块全面升级',
    excerpt: 'JMTT最新版本v4.2正式上线！本次更新重点优化了智能分析模块，新增可视化数据看板、自定义报表生成以及AI预测分析功能，帮助用户更直观地洞察业务趋势。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20dashboard%20interface%20with%20charts%20and%20data%20visualization%2C%20clean%20minimal%20design%2C%20warm%20accent%20colors%2C%20dark%20theme%20with%20gold%20highlights%2C%20modern%20UI%20design&width=800&height=450&seq=article-03&orientation=landscape',
    author: 'JMTT产品团队',
    date: '2026-08-05',
    readTime: '6分钟',
    tags: ['版本更新', '智能分析', '新功能']
  },
  {
    id: 4,
    category: 'case',
    title: '某头部电商企业借助JMTT实现年增长200%的秘诀',
    excerpt: '本文将深入剖析某头部电商企业如何通过JMTT平台的数据管理服务和智能营销工具，在一年内实现了用户量和交易额的双重突破，年增长率达到惊人的200%。',
    image: 'https://readdy.ai/api/search-image?query=E-commerce%20business%20growth%20concept%2C%20modern%20office%20team%20analyzing%20data%20charts%20on%20large%20screen%2C%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20clean%20minimalist%20style&width=800&height=450&seq=article-04&orientation=landscape',
    author: 'JMTT客户成功团队',
    date: '2026-08-03',
    readTime: '10分钟',
    tags: ['客户案例', '电商', '增长']
  },
  {
    id: 5,
    category: 'industry',
    title: '2026年企业数字化转型趋势：JMTT为您解读五大关键方向',
    excerpt: '数字化转型已成为企业发展的必经之路。本文将结合行业最新趋势与JMTT平台实践经验，为企业管理者解读2026年数字化转型的五大关键方向，助力企业抢占先机。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20transformation%20concept%20with%20abstract%20network%20connections%2C%20warm%20earth%20tones%2C%20modern%20geometric%20design%2C%20clean%20minimal%20aesthetic%2C%20professional%20technology%20illustration&width=800&height=450&seq=article-05&orientation=landscape',
    author: 'JMTT研究院',
    date: '2026-08-01',
    readTime: '7分钟',
    tags: ['行业趋势', '数字化转型', '企业管理']
  },
  {
    id: 6,
    category: 'tutorial',
    title: 'JMTT高级技巧：5个你不可不知的效率提升方法',
    excerpt: '已经熟悉JMTT基本操作？这篇进阶教程将分享5个实用的高级技巧，包括快捷键操作、自动化工作流配置以及个性化设置优化，帮助你将使用效率提升到新的高度。',
    image: 'https://readdy.ai/api/search-image?query=Productivity%20workspace%20with%20keyboard%20and%20modern%20tech%20gadgets%2C%20clean%20minimal%20desk%2C%20warm%20ambient%20light%2C%20professional%20setup%2C%20simple%20elegant%20composition&width=800&height=450&seq=article-06&orientation=landscape',
    author: 'JMTT教程团队',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['高级技巧', '效率提升', 'JMTT教程']
  },
  {
    id: 7,
    category: 'platform',
    title: 'JMTT荣获2026年度最佳企业服务平台大奖',
    excerpt: '在刚刚落幕的2026年中国企业服务大会上，JMTT凭借卓越的产品体验和出色的用户口碑，荣获"年度最佳企业服务平台"大奖，这是对JMTT团队持续努力的最好肯定。',
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20trophy%2C%20elegant%20modern%20venue%2C%20warm%20golden%20lighting%2C%20professional%20atmosphere%2C%20clean%20sophisticated%20design&width=800&height=450&seq=article-07&orientation=landscape',
    author: 'JMTT官方',
    date: '2026-07-25',
    readTime: '4分钟',
    tags: ['获奖', '行业认可', '平台荣誉']
  },
  {
    id: 8,
    category: 'case',
    title: '从0到100万：一家初创企业借助JMTT快速成长的实战经验',
    excerpt: '一家成立仅两年的初创企业，如何在JMTT平台的帮助下，从零起步实现百万用户突破？本文详细记录了他们的实战历程和宝贵经验，为正在路上的创业者提供参考。',
    image: 'https://readdy.ai/api/search-image?query=Startup%20team%20brainstorming%20in%20modern%20office%2C%20creative%20workspace%20with%20sticky%20notes%20and%20whiteboard%2C%20warm%20lighting%2C%20energetic%20atmosphere%2C%20clean%20minimal%20design&width=800&height=450&seq=article-08&orientation=landscape',
    author: 'JMTT客户成功团队',
    date: '2026-07-20',
    readTime: '9分钟',
    tags: ['客户案例', '创业', '增长故事']
  },
  {
    id: 9,
    category: 'update',
    title: 'JMTT移动端重大更新：全新界面设计与离线模式上线',
    excerpt: 'JMTT移动端迎来v3.0重大更新！全新的界面设计更加简洁直观，新增的离线模式让您即使在没有网络的环境下也能继续工作，网络恢复后自动同步，体验大幅提升。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20clean%20app%20interface%2C%20minimalist%20design%2C%20warm%20lighting%2C%20elegant%20flat%20lay%20composition%2C%20professional%20mobile%20app%20showcase&width=800&height=450&seq=article-09&orientation=landscape',
    author: 'JMTT产品团队',
    date: '2026-07-18',
    readTime: '5分钟',
    tags: ['移动端', '版本更新', '离线模式']
  }
];